import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';
import { Heading, Text, Button, Badge } from '@simplywallst/ui-core';
import { useTracking } from 'react-tracking';
import styled from 'styled-components';
import { RenderUntilExpiry } from '@/components/RenderUntilExpiry';

const Link = styled('a')`
  display: inline-block;
`;

const LinkButton = styled(Button)`
  cursor: pointer;
`;

/**
 *
 * The ScreenerNLP component is toggled via unleash flag: https://us.app.unleash-hosted.com/usbb1018/projects/Data/features/nlp-screener
 *
 */
export function ScreenerNLP() {
  const { trackEvent, Track } = useTracking();
  const openTypeformDrawer = useTypeformDrawer('EUG8bzuz');
  return (
    <Track>
      <span>
        <Link
          href="https://simplywall.st/nlp"
          target="_blank"
          rel="nofollow noreferrer"
          onClick={() =>
            trackEvent({
              action: 'click',
              modifier: 'ai stock screener',
            })
          }
        >
          <Heading as="h3" color="brand01">
            AI Stock Screener
          </Heading>
        </Link>
        <RenderUntilExpiry startedFrom="2023-06-20" expiresIn={{ months: 6 }}>
          <Badge tone="attention">New</Badge>
        </RenderUntilExpiry>
      </span>
      <Text typography="small">
        Introducing the AI Stock Screener, designed to help you easily find new
        and interesting companies that match your investment preferences. You
        can search for companies by their financials, niche industry, products
        or similarity to other companies.
      </Text>
      <Text typography="small">
        This feature is currently in the prototype stage and we welcome any
        feedback you can provide by completing{' '}
        <LinkButton as="a" styleType="strongLink" onClick={openTypeformDrawer}>
          this form
        </LinkButton>
        .
      </Text>
    </Track>
  );
}
